import _ from 'underscore'
import LegendConfig from 'pages/Device/ThermostatRthPanel/Legend/legendItemsConfig'
import { updateYaxisRangeOnZoom } from 'pages/Device/ThermostatRthPanel/Chart/chartOptions'

const LEGEND_LOCAL_STORAGE_NAME = 'Plotly_SelectedLegends'
const LEGEND_DEFAULT_ALERTS = ['critical', 'major', 'major-sda']
const HEHM_LEGEND_DEFAULT_ALERTS = ['critical-sda', 'major-sda', 'minor-sda']
const LEGEND_DEFAULT_DEVICE_CONNECTION_STATUS = ['restarted']

export const updateLayoutOnResetZoom = (isZoomed, updatedLayout, initialLayout) => {
  const clonedInitialLayout = JSON.parse(JSON.stringify(initialLayout))

  if (isZoomed && updatedLayout) {
    clonedInitialLayout.xaxis.range = [...updatedLayout.xaxis.range]
    clonedInitialLayout.yaxis5.range = [...updatedLayout.yaxis5.range]
    clonedInitialLayout.yaxis6.range = [...updatedLayout.yaxis6.range]

    updateYaxisRangeOnZoom(clonedInitialLayout)
    return clonedInitialLayout
  } else {
    return clonedInitialLayout
  }
}

export const updateLocalStorageAndGetAllTracesToDisplay = (deviceId, selectedLegends, traces, zoneTraces, stageTraces) => {
  updateLocalStorage(deviceId, selectedLegends) // update selected legends localstorage
  _.forEach(traces, (trace) => {
    if (selectedLegends.series.includes(trace.seriesName)) {
      trace.opacity = 1
    } else {
      trace.opacity = 0
    }
  })

  _.forEach(zoneTraces, (trace) => {
    const selectedZoneSeries = _.find(selectedLegends.zoneSeries || [], (zone) => zone.name === trace.group)

    if (selectedZoneSeries && selectedZoneSeries.series.includes(trace.seriesName)) {
      trace.opacity = 1
    } else {
      trace.opacity = 0
    }
  })

  return (traces || []).concat(zoneTraces || []).concat(stageTraces || [])
}

export const getDefaultSelectedSeriesItems = (deviceId, rthData, isHehm = false) => {
  const selectedLegendsJSON = localStorage.getItem(LEGEND_LOCAL_STORAGE_NAME)
  const selectedLegendsInLocalStorage = selectedLegendsJSON ? JSON.parse(selectedLegendsJSON) : false
  const currentDeviceLegendsInLocalStorage = selectedLegendsInLocalStorage[deviceId] ? selectedLegendsInLocalStorage[deviceId] : false
  const zoneNames = _.map(rthData?.zones, (zone) => zone.name)
  const defaultAlerts = isHehm ? HEHM_LEGEND_DEFAULT_ALERTS : [...LEGEND_DEFAULT_ALERTS, ...LEGEND_DEFAULT_DEVICE_CONNECTION_STATUS]

  if (currentDeviceLegendsInLocalStorage) {
    const defaultSeries = currentDeviceLegendsInLocalStorage.series

    const defaultSelectZones = _.map(zoneNames || [], zoneName => {
      return {
        name: zoneName,
        series: _.find(currentDeviceLegendsInLocalStorage.zoneSeries, (existingZone) => existingZone.name === zoneName)?.series || []
      }
    })

    return {
      series: defaultSeries,
      zoneSeries: defaultSelectZones,
      alerts: currentDeviceLegendsInLocalStorage.alerts || defaultAlerts,
      showHoverData: currentDeviceLegendsInLocalStorage.showHoverData

    }
  } else {
    let indoorUnitlegendItems
    if (isHehm) {
      indoorUnitlegendItems = LegendConfig.HEHM_INDOOR_LEGEND_ITEMS
    } else if (rthData?.isControlHub) {
      indoorUnitlegendItems = _.union(LegendConfig.INDOOR_UNIT_LEGEND_ITEMS, LegendConfig.CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS)
    } else {
      indoorUnitlegendItems = LegendConfig.INDOOR_UNIT_LEGEND_ITEMS
    }

    const outdoorLegendItems = isHehm ? LegendConfig.HEHM_OUTDOOR_LEGEND_ITEMS : _.union(LegendConfig.OUTDOOR_LEGEND_ITEMS, LegendConfig.OUTDOOR_UNIT_LEGEND_ITEMS)
    const allSeriesLegendItems = _.union(indoorUnitlegendItems, outdoorLegendItems)

    const defaultSeries = _.map(_.filter(allSeriesLegendItems, (item) => item.visible), (item) => item.seriesName)
    const defautZoneSeries = isHehm ? [] : _.map(_.filter(LegendConfig.INDOOR_ZONE_LEGEND_ITEMS, (item) => item.visible), (item) => item.seriesName)
    const defaultSelectZones = _.map(zoneNames, zoneName => { return { name: zoneName, series: defautZoneSeries } })

    return {
      series: defaultSeries,
      zoneSeries: defaultSelectZones,
      alerts: defaultAlerts,
      showHoverData: true
    }
  }
}

const updateLocalStorage = (deviceId, selectedLegends) => {
  const selectedLegendsInLocalStorage = localStorage.getItem(LEGEND_LOCAL_STORAGE_NAME) ? JSON.parse(localStorage.getItem(LEGEND_LOCAL_STORAGE_NAME)) : {}
  selectedLegendsInLocalStorage[deviceId] = selectedLegends
  localStorage.setItem(LEGEND_LOCAL_STORAGE_NAME, JSON.stringify(selectedLegendsInLocalStorage))
}
